module.exports = __webpack_public_path__ + "static/media/icon_pin.4df295f9.svg";